<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/estados/#estados">Estados</a>
            </li>
            <li class="is-size-5">
                <a href="/sepomex/estados/#estado">Estado</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="estados">1.- Estados</h3>
        <strong>Enpoint con la lista de estados, siempre regresa un array de objetos, incluso aunque sea solo un elemento</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/estados/</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>countryCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'MEX')</li>
                    </ul>
                </li>
                <li>
                    <strong>countryId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'MEX')</li>
                    </ul>
                </li>
                <li>
                    <strong>stateName</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'Chihuahua')</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 1 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/estados?countryCode=mex</h5>
            <code>[
                {
                    "id": 30,
                    "countryId": "MEX",
                    "countryCode": "MEX",
                    "stateCode": "30",
                    "stateName": "VERACRUZ",
                    "stateAbbr": "VZ",
                    "stateAbbrBureau": "VER"
                },
                {
                    "id": 29,
                    "countryId": "MEX",
                    "countryCode": "MEX",
                    "stateCode": "29",
                    "stateName": "TLAXCALA",
                    "stateAbbr": "TL",
                    "stateAbbrBureau": "TLA"
                },
                {
                    "id": 27,
                    "countryId": "MEX",
                    "countryCode": "MEX",
                    "stateCode": "27",
                    "stateName": "TABASCO",
                    "stateAbbr": "TC",
                    "stateAbbrBureau": "TAB"
                }
                ...
            ]</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/estados?countryCode=mex&stateName=chi</h5>
            <code>[
                {
                    "id": 8,
                    "countryId": "MEX",
                    "countryCode": "MEX",
                    "stateCode": "08",
                    "stateName": "CHIHUAHUA",
                    "stateAbbr": "CH",
                    "stateAbbrBureau": "CHI"
                },
                {
                    "id": 7,
                    "countryId": "MEX",
                    "countryCode": "MEX",
                    "stateCode": "07",
                    "stateName": "CHIAPAS",
                    "stateAbbr": "CS",
                    "stateAbbrBureau": "CHS"
                }
            ]</code>
        </pre>
        <hr />

        <h3 class="is-size-3" id="estado">2.- Estado</h3>
        <strong>Enpoint con el detalle de un solo estado, siempre regresa un objeto.</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/estado/{id}</code>
        </p>

        <h5 class="is-size-6">Parametros:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato number (Ej. 8)</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/estado/8</h5>
            <code>{
                "id": 8,
                "countryId": "MEX",
                "countryCode": "MEX",
                "stateCode": "08",
                "stateName": "CHIHUAHUA",
                "stateAbbr": "CH",
                "riskProbability": "2.0",
                "riskImpact": "2.0",
                "isoCode": "MX-CHH"
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/estado/3</h5>
            <code>{
                "id": 3,
                "countryId": "MEX",
                "countryCode": "MEX",
                "stateCode": "03",
                "stateName": "BAJA CALIFORNIA SUR",
                "stateAbbr": "BS",
                "riskProbability": "2.0",
                "riskImpact": "2.0",
                "isoCode": "MX-BCS"
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 3 de Ejemplo, pais no encontrado:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/estado/1000</h5>
            <code>{}</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexEstados',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
